export default __webpack_public_path__ + "static/media/famele.7a4439dc.png";